module.exports = __webpack_public_path__ + "img/MERS-White.a73e9489.png";